import React, { useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useImmer } from "use-immer";

import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { Styles } from "@intelligems/ig-theme/theme";
import type { StackProps } from "@mui/material/Stack";
import Stack from "@mui/material/Stack";
import * as Sentry from "@sentry/react";

type ErrorBoundaryMessageProps = StackProps;

const styles = {
  main: {
    py: 4,
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
} satisfies Styles;

export const ErrorBoundaryMessage = ({
  children,
  sx,
  ...rest
}: ErrorBoundaryMessageProps) => {
  return (
    <Stack sx={{ ...styles.main, ...sx }} {...rest}>
      {children || (
        <IgTypography variant={"h3"}>Oops! Something went wrong!</IgTypography>
      )}
    </Stack>
  );
};

export const IgErrorBoundary = (props: Sentry.ErrorBoundaryProps) => {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorBoundaryMessage />} {...props} />
  );
};

export const HiddenErrorBoundary = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [state, setState] = useImmer({ hasError: false });

  if (state.hasError) {
    return null;
  }

  return (
    <ErrorBoundary
      onError={(error: unknown, errorInfo: unknown) => {
        console.log(error, errorInfo);
        setState((draft) => {
          draft.hasError = true;
        });
      }}
      fallbackRender={() => null}
    >
      {children}
    </ErrorBoundary>
  );
};
